import React from 'react'
import Hero from '../components/Hero'
import GamesSection from '../components/GamesSection'
import './Home.css'

const Home = () => {
  return (
    <main className="home">
      <Hero />
      <GamesSection />
    </main>
  )
}

export default Home
